export class InfectedDataOverTime {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "infectedDates",
            "baseName": "infectedDates",
            "type": "Array<InfectedDateSize>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InfectedDataOverTime.attributeTypeMap;
    }
    constructor() {
    }
}
